module.exports = __webpack_public_path__ + "assets/404.png";


//////////////////
// WEBPACK FOOTER
// ./assets/404.png
// module id = 196
// module chunks = 0